import { render, staticRenderFns } from "./ChipsItem.vue?vue&type=template&id=253e4d70&"
import script from "./ChipsItem.vue?vue&type=script&lang=js&"
export * from "./ChipsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports